import React, { useState, useEffect, useRef } from "react";
import { remoteConfig, fetchAndActivate, getValue } from '../../configuration';
import "./login.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { loginAction } from "../../actions/loginAction";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { NotificationManager } from "react-notifications";
import { safeEncode } from "../../common/encoder";
import Cookies from "js-cookie";
import Loader from "../loaderComponent/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import {
  loginRolesAction,
  allLanguageListAction,
} from "../../actions/loginAction";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { hasPermission, hasAnyPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const LoginForm = () => {
  const [state, setDataState] = useState({
    role: "",
    userid: "",
    password: "",
    language: "",
  });
  const [Error, setError] = useState({
    roleError: "",
    useridError: "",
    passwordError: "",
    languageError: "",
  });
  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });
  const [isLoading, setLoading] = useState(false);
  const [loginrolelist, setLoginroleList] = useState([]);
  const [languagelist, setLanguageList] = useState([]);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [captchaToken, setIsCaptchaToken] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryData, setCountryData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const recaptchaRef = useRef(null);

  const { countryCode, countryRegion } = useParams();
  const RouteEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || ""

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);

        const configString = getValue(remoteConfig, process.env.REACT_APP_FIREBASE_DEV_KEY).asString();
        const parseConfig = JSON.parse(configString);
        setCountryData(parseConfig);

        const country = parseConfig.find(
          item => item?.country_code === countryCode && item?.region === countryRegion
        );
        if (country) {
          setSelectedCountry(country?.country_code);
          localStorage.setItem('countryName', country?.country);
          localStorage.setItem('countryFlag', country?.country_flag);
          localStorage.setItem('countryPhoneCode', country?.country_phone_code);
          localStorage.setItem('countryLatLongCode', country?.lat_long_country_code);
          localStorage.setItem('countryBackendUrl', country?.backend_url);
          localStorage.setItem('countryPhoneLength', country?.country_phone_length);
          localStorage.setItem('countryMinPhoneLength', country?.country_min_phone_length);
          localStorage.setItem('countryCode', country.country_code);
        } else {
          navigate("/");
          localStorage.clear('countryName');
        }
      } catch (error) {
        NotificationManager.error(error.message || 'There is an error in firebase');
      }
    };

    fetchConfig();
  }, [countryCode]);

  useEffect(() => {
    if(state?.language != '' && selectedCountry !== ''){
      loginrolesdata();
    }
  }, [state.language, selectedCountry]);

  useEffect(() => {
    if (selectedCountry !== '') {
      getlanguagelist();
      handleChangeLanguage("en");
    }
  }, [selectedCountry]);

  const handleCountryChange = (event) => {
    event.preventDefault();
    const countryCode = event.target.value;
    const country = countryData?.find(item => item?.country_code === countryCode);

    if (country) {
      const countryRegion = country?.region;
      localStorage.setItem('countryName', country?.country);
      localStorage.setItem('countryFlag', country?.country_flag);
      localStorage.setItem('countryPhoneCode', country?.country_phone_code);
      localStorage.setItem('countryLatLongCode', country?.lat_long_country_code);
      localStorage.setItem('countryBackendUrl', country?.backend_url);
      localStorage.setItem('countryPhoneLength', country?.country_phone_length);
      localStorage.setItem('countryMinPhoneLength', country?.country_min_phone_length);
      localStorage.setItem('countryCode', country.country_code);
      setSelectedCountry(country?.country_code);
      setDataState({
        ...state,
        role: "",
        userid: "",
        password: "",
        language: "",
      });

      setError({
        roleError: "",
        useridError: "",
        passwordError: "",
        languageError: "",
      });

      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        setIsCaptchaVerified(false);
      }

      const formattedRouteEndpoint = RouteEndPoint.replace(/\/+$/, "");
      const newUrl = `${formattedRouteEndpoint}/${countryRegion}/${countryCode}`;
      window.history.replaceState({}, '', newUrl);
    }
  };

  const handleChangeLanguage = (language, languageCode) => {
    Cookies.set("language", language, {
      expires: 1,
    });
    Cookies.set("languageCode", languageCode, {
      expires: 1,
    });
    localStorage.setItem("languageCode", languageCode);
    i18n.changeLanguage(language);

    if (languageCode === "ar") {
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
    }
  };

  const languageCode = localStorage.getItem("languageCode");

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    if (name === "language") {
      const selectedOption = evt.target.options[evt.target.selectedIndex];
      const dataLangValue = selectedOption.getAttribute("data-lang");
      const dataLangCode = selectedOption.getAttribute("data-lang-code")
      handleChangeLanguage(
        dataLangValue.toLowerCase() === "spanish" ? "es" :
          dataLangValue.toLowerCase() === "english" ? "en" :
            dataLangValue.toLowerCase() === "bangla" ? "bn" :
              dataLangValue.toLowerCase() === "swahili" ? "sw" :
                dataLangValue.toLowerCase() === "arabic" ? "ar" :
                  dataLangValue.toLowerCase() === "french" ? "fr" :
                    "en",
        dataLangCode
      );
    }
  };

  async function loginrolesdata() {
    setLoading(true);
    let response = await dispatch(loginRolesAction(state.language));
    if (response == 200 || response != null) {
      setLoginroleList(response.data.data);
      setLoading(false);
    } else if (response === undefined) {
      setLoading(false);
    }
  }
  async function getlanguagelist() {
    setLoading(true);
    let response = await dispatch(allLanguageListAction());
    if (response == 200 || response != null) {
      setLanguageList(response.data.data);
      const englishLanguage = response.data.data?.find(
        (item) => item?.language?.toLowerCase() === "english"
      );
      setDataState({
        ...state,
        language: englishLanguage?.id,
      });
      handleChangeLanguage("en", englishLanguage?.language_code);
      setLoading(false);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  const handleCaptchaChange = (response) => {
    setIsCaptchaVerified(true);
    setIsCaptchaToken(response);
  };
  const handleCaptchaExpired = () => {
    setIsCaptchaVerified(false);
  };

  const onclicklogin = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (isCaptchaVerified) {
        let data = {
          email: state.userid,
          password: state.password,
          role: state.role,
          language: state.language,
          captcha: captchaToken
        };
        setLoading(true);
        setButtonDisabled(true);
        let response = await dispatch(loginAction(data));
        if (response === undefined) {
          setLoading(false);
          setButtonDisabled(false);
        } else if (response.status === 429) {
          if (response?.data?.status === false && recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
          setIsCaptchaVerified(false);
          setLoading(false);
          setButtonDisabled(false);
        } else if (response.status === 400) {
          if (response?.data?.success === false && recaptchaRef.current) {
            recaptchaRef.current.reset();
            setIsCaptchaVerified(false);
          }
          setLoading(false);
          setButtonDisabled(false);
        } else if (response?.data?.success === false) {
          if (response?.data?.success === false && recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
          NotificationManager.error(response.data.message);
          setLoading(false);
          setButtonDisabled(false);
          setDataState({
            email: "",
            password: "",
            role_id: "",
          });
        } else if (response.data.success === true) {
          setLoading(false);
          Cookies.set("accessToken", safeEncode(response.data.user.Token), {
            expires: 1,
          });
          Cookies.set("role", safeEncode(response.data.user.role), { expires: 1 });
          Cookies.set("country_id", safeEncode(response.data.user.country_id), {
            expires: 1,
          });
          const permissions = response?.data?.user?.permissions;
          localStorage.setItem('userPermission', JSON.stringify(permissions));
          Cookies.set(
            "admin_user_id",
            safeEncode(response.data.user.admin_user_id),
            {
              expires: 1,
            }
          );
          Cookies.set("permissions", safeEncode(response.data.user.permissions), {
            expires: 1,
          });
          Cookies.set("language_id", safeEncode(state.language), {
            expires: 1,
          });
          const navigationMap = [
            { permission: PERMISSIONS.CAN_VIEW_PGM_LIST, path: "/pgmlist" },
            { permission: PERMISSIONS.CAN_CREATE_PGM_USER, path: "/partner" },
            { permission: PERMISSIONS.CAN_VIEW_ORDERS, path: "/partorderlist" },
            { permission: PERMISSIONS.CAN_VIEW_PARTS, path: "/partslist" },
            { permission: PERMISSIONS.CAN_VIEW_PART_CATALOGUES, path: "/partcatelogue" },
          ];
          const route = navigationMap.find(({ permission }) => hasPermission(permission))?.path;
          if (route) {
            navigate(route);
          } else if (hasAnyPermission([
            PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS,
            PERMISSIONS.CAN_VIEW_TRAINING_MODULE
          ])) {
            navigate("/productTraining");
          }
          NotificationManager.success(response.data.message);
          setDataState({
            email: "",
            password: "",
            role_id: "",
          });
        }
      } else {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        NotificationManager.error(t("login.recaptchaeError"));
        setButtonDisabled(false);
      }
    }
  };

  let validateForm = () => {
    let formIsValid = true;
    if (state.role === "") {
      formIsValid = false;
      setError({ roleError: t("login.roleError") });
    } else if (state.userid === "") {
      formIsValid = false;
      setError({ useridError: t("login.userIdError") });
    } else if (state.password === "") {
      formIsValid = false;
      setError({ passwordError: t("login.passwordError") });
    } else if (state.language === "") {
      formIsValid = false;
      setError({ languageError: "Please select Language" });
    } else {
      setError(" ");
    }
    return formIsValid;
  };

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  const handleforgetclick = () => {
    navigate("/forgetpassword", { state: { languageId: state.language } });
  };


  return (
    <div>
      <div className="login_container">
        <div className="loginfirstpara">
          <div className="tvs_logo">
            <img height='80px' width= '294px' src={Image_Url.TVSLOGO} />
          </div>
          <div className="login_main">
            <div className="login_tvsadminfirst">
              <img src={Image_Url.TVSADMIN} />
              <span className="Login_text">{t("login.login")}</span>
            </div>
            <div className="login_tvsadminsecond">
              <span className="login_textsecond">
                {t("login.logininstruction")}
              </span>
            </div>
            <div className="login_thirdpara">
              <div className="loginthirdpara">
                <div className="select-input-wrapper">
                  <label className="country-label" htmlFor="country">
                    {t("login.selectCountry")}
                  </label>
                  <select value={selectedCountry} onChange={handleCountryChange} className="login-select">
                    <option value="" disabled>Select a country</option>
                    {countryData && countryData?.length > 0 ? (
                      countryData?.map((country, index) => (
                        <option key={index} value={country?.country_code}>
                          {country?.country}
                        </option>
                      ))
                    ) : (
                      <option disabled>No countries available</option>
                    )}
                  </select>
                </div>

                <div className="select-input-wrapper">
                  <label className="language-label" htmlFor="language">
                    {t("login.selectLanguage")}
                  </label>
                  <select
                    className="login-select"
                    id="language"
                    name="language"
                    value={state.language}
                    onChange={handleChange}
                  >
                    <option value="" data-lang="">{t("login.selectLanguage")}</option>
                    {languagelist?.map((item, index) => (
                      <option
                        value={item.id}
                        data-lang={item.language}
                        data-lang-code={item.language_code}
                        key={index}
                      >
                        {item.language}
                      </option>
                    ))}
                  </select>
                </div>
                {Error.languageError && (
                  <span className="ErrorMessage  montserrat-font">
                    {Error.languageError}
                  </span>
                )}
              </div>
              <div className="loginthirdpara">
                <div className="input-wrapper">
                  <label className="required" htmlFor="first">
                    {t("login.selectRole")}
                  </label>
                  <select
                    className="login-select"
                    id="role"
                    name="role"
                    value={state.role}
                    onChange={handleChange}
                  >
                    <option value="">{t("login.selectRole")}</option>
                    {loginrolelist?.map((item, i) => (
                      <option key={i} data-role={item.role} value={item.id}>{item.role}</option>
                    ))}
                  </select>
                </div>
              </div>
              {Error.roleError && (
                <span className="ErrorMessage  montserrat-font">
                  {Error.roleError}
                </span>
              )}
              <div className="loginthirdpara">
                <div className="input-wrapper">
                  <label className="required" htmlFor="search">
                    {t("login.userid")}
                  </label>
                  <input
                    type="text"
                    placeholder={t("login.enterUserId")}
                    name="userid"
                    value={state.userid}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {Error.useridError && (
                <span className="ErrorMessage  montserrat-font">
                  {Error.useridError}
                </span>
              )}
              <div className="loginthirdpara">
                <div className="input-wrapper">
                  <label className="required" htmlFor="search">
                    {t("login.password")}
                  </label>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    id="password"
                    placeholder={t("login.enterPassword")}
                    name="password"
                    value={state.password}
                    onChange={handleChange}
                  />
                  <span
                    className={`pass-icon ${isPasswordVisible ? "visible" : ""
                      }`}
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>
              {Error.passwordError && (
                <span className="ErrorMessage  montserrat-font">
                  {Error.passwordError}
                </span>
              )}
              <div className="recaptchaContainer">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_CAPTCHA}
                  onChange={handleCaptchaChange}
                  onExpired={handleCaptchaExpired}
                />
              </div>
            </div>
            <div className="login_button">
              <button className="login-now-buttons" onClick={onclicklogin} disabled={isButtonDisabled}>
                {isLoading ? (
                  <Loader className="login-loader" />
                ) : (
                  <>
                    {t("login.loginNow")}{" "}
                    {languageCode === "ar" ? (
                      <FaArrowLeftLong className="loginnows" />
                    ) : (
                      <FaArrowRightLong className="loginnows" />
                    )}
                  </>
                )}
              </button>
            </div>
            <div className="Forgettextdiv">
              <span className="Forget_text" onClick={handleforgetclick}>
                {t("login.forgotPassword")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
